const DEFAULT_API_URL = 'https://api.ducknseek.com';
const API_URL = (import.meta.env.VITE_API_URL ?? '').trim() || DEFAULT_API_URL;

export const Constant = {
    API_URL,
    GET_DUCKS_AND_CRUISE_BY_UUID: '/get-cruise-info-from-duck',
    SET_DUCK_FOUND: "/duck-found",
    GET_DUCK_BY_UUID: "/get-duck-from-uuid",
    SEND_MESSAGE: "/send-message",
    HIDE_DUCK: "/hide-duck",
    CLAIM_FOUND_DUCK: '/auth/claim-found-duck',
    LOGIN: "/auth/login",
    REGISTER: "/auth/register",
    ADD_CRUISE: "/auth/add-cruise",
    MODIFY_CRUISE: "/auth/modify-cruise",
    ADD_DUCK: '/auth/add-duck',
    ADD_MULTIPLE_DUCKS: '/auth/add-multiple-ducks',
    UPDATE_DUCK_IMAGE: '/auth/update-duck-image',
    GENERATE_QR_CODES: '/auth/generate-cruise-qrcodes',
    GENERATE_DUCK_QR: '/auth/generate-duck-qrcode',
    RESET_DUCK: '/auth/reset-duck',
    RESET_CRUISE_DUCKS: '/auth/reset-cruise-ducks',
    CONFIRM_EMAIL: '/confirm',
    RESEND_CONFIRMATION: '/resend-confirmation',
    UPDATE_EMAIL: '/update-email',
    RESET_PASSWORD: '/reset-password',
    FORGOT_PASSWORD: '/forgot-password',
    DUCK_FOUND: '/duck-found',
    GET_CRUISE_MESSAGES: '/auth/cruise',
    GET_DUCK_MESSAGES: '/auth/duck',
    POLL_CRUISE_MESSAGES: '/auth/cruise',
    PACKAGES: '/packages',
    MY_CRUISES: '/auth/my-cruises',
    LEADERBOARD: '/leaderboard',
}